import { createSlice } from "@reduxjs/toolkit";

const occupationSlice = createSlice({
    name:'occupation',
    initialState:{
        occupation:[]
    },
    reducers: {
        addOccupation : (state,action) => {
            console.log(action)
            //state.push(action.payload)
            state.occupation = [...state.occupation,action.payload]
        },
        // removeOccupation(){
        //     return state.occupation.filter((item)=> item.id != action.payload);
        // }
    }
});

export const { addOccupation } = occupationSlice.actions;
export default occupationSlice.reducer;